
export const navigation = [
  { name: 'Accueil', href: '/' },
  { name: 'Services', href: '/services' },
  { name: 'Portfolio', href: '/portfolio' },
  { name: 'À propos', href: '/about' },
  { name: 'Contact', href: '/contact' }
];

export const languages = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
  { code: 'ro', name: 'Română', flag: '🇷🇴' }
];

export const services = [
  {
    id: 1,
    title: 'Travaux de rénovation',
    description: 'Rénovation complète d\'appartements, maisons et locaux commerciaux avec des matériaux de qualité',
    icon: 'ri-hammer-line',
    image: 'https://public.readdy.ai/ai/img_res/385df635a01f4e3bf9154ccef402b061.jpg'
  },
  {
    id: 2,
    title: 'Travaux de peinture',
    description: 'Peinture intérieure et extérieure des murs, plafonds, façades avec une approche professionnelle',
    icon: 'ri-brush-line',
    image: 'https://readdy.ai/api/search-image?query=Professional%20painters%20working%20on%20interior%20walls%20in%20Swiss%20home%2C%20clean%20white%20walls%20being%20painted%2C%20modern%20tools%20and%20equipment%2C%20minimalist%20clean%20workspace%2C%20natural%20lighting&width=400&height=300&seq=painting1&orientation=landscape'
  },
  {
    id: 3,
    title: 'Travaux de plâtrerie',
    description: 'Nivellement des murs, plâtre décoratif, restauration des surfaces',
    icon: 'ri-tools-line',
    image: 'https://readdy.ai/api/search-image?query=Professional%20plastering%20work%20on%20walls%20in%20Swiss%20building%2C%20smooth%20wall%20surfaces%20being%20prepared%2C%20construction%20tools%20and%20materials%2C%20clean%20work%20environment%2C%20quality%20craftsmanship&width=400&height=300&seq=plastering1&orientation=landscape'
  },
  {
    id: 4,
    title: 'Revêtements de sol',
    description: 'Pose de parquet, stratifié, carrelage, linoléum avec préparation du support',
    icon: 'ri-layout-grid-line',
    image: 'https://static.readdy.ai/image/42d13efc32449c379a28fcec32248951/54f23b008e6beda815f7bd14f3356bfe.jpeg'
  },
  {
    id: 5,
    title: 'Travaux de façade',
    description: 'Isolation des façades, revêtement, réparation et peinture des murs extérieurs',
    icon: 'ri-building-line',
    image: 'https://readdy.ai/api/search-image?query=Professional%20facade%20work%20on%20Swiss%20building%20exterior%2C%20workers%20on%20scaffolding%20renovating%20building%20facade%2C%20clean%20modern%20architecture%2C%20quality%20construction%20materials%2C%20Alpine%20background&width=400&height=300&seq=facade1&orientation=landscape'
  }
];

export const contact = {
  phone: '+41 77 218 45 02',
  email: 'domdavida86@gmail.com',
  address: 'Suisse, cantons de Vaud et Genève',
  whatsapp: '+41772184502',
  workingHours: 'Lun-Ven: 7:00-17:00'
};

export const portfolio = [
  // Interior Finishing Works
  {
    id: 1,
    title: 'Travaux de plâtrerie en appartement',
    category: 'Finitions intérieures',
    location: 'Genève',
    image: 'https://readdy.ai/api/search-image?query=Professional%20interior%20plastering%20work%20in%20Swiss%20apartment%2C%20smooth%20white%20walls%20being%20finished%2C%20high%20quality%20craftsmanship%2C%20clean%20modern%20interior%20space%2C%20natural%20lighting%20showing%20perfect%20wall%20texture%20and%20finish&width=600&height=400&seq=portfolio-plaster1&orientation=landscape',
    description: 'Lissage des murs et plâtre décoratif dans un appartement de 4 pièces'
  },
  {
    id: 2,
    title: 'Travaux de menuiserie en maison',
    category: 'Finitions intérieures',
    location: 'Vaud',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20custom%20woodwork%20installation%20in%20Swiss%20home%20interior%2C%20elegant%20wooden%20panels%20and%20trim%2C%20quality%20carpentry%20craftsmanship%2C%20warm%20natural%20wood%20tones%2C%20modern%20minimalist%20design%20with%20professional%20finish&width=600&height=400&seq=portfolio-wood1&orientation=landscape',
    description: 'Installation de panneaux en bois et travaux de menuiserie'
  },
  {
    id: 3,
    title: 'Finitions complètes de bureau',
    category: 'Finitions intérieures',
    location: 'Lausanne',
    image: 'https://readdy.ai/api/search-image?query=Modern%20office%20interior%20finishing%20in%20Lausanne%20Switzerland%2C%20professional%20construction%20work%20with%20clean%20walls%20and%20quality%20materials%2C%20contemporary%20business%20space%20design%2C%20bright%20natural%20lighting%2C%20Swiss%20quality%20standards&width=600&height=400&seq=portfolio-office1&orientation=landscape',
    description: "Finitions intérieures complètes d'un espace commercial"
  },

  // Painting and Coatings
  {
    id: 4,
    title: 'Peinture des murs et plafonds',
    category: 'Peinture et revêtements',
    location: 'Genève',
    image: 'https://readdy.ai/api/search-image?query=Professional%20interior%20painting%20work%20in%20Geneva%20apartment%2C%20painters%20applying%20smooth%20white%20paint%20on%20walls%20and%20ceilings%2C%20clean%20workspace%20with%20quality%20tools%2C%20perfect%20finish%20and%20attention%20to%20detail%2C%20bright%20natural%20lighting&width=600&height=400&seq=portfolio-paint1&orientation=landscape',
    description: "Peinture professionnelle d'un espace résidentiel"
  },
  {
    id: 5,
    title: 'Revêtements décoratifs',
    category: 'Peinture et revêtements',
    location: 'Montreux',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20decorative%20wall%20coating%20in%20Swiss%20luxury%20home%2C%20textured%20decorative%20finish%20with%20sophisticated%20design%2C%20high-end%20interior%20materials%2C%20professional%20application%20technique%2C%20warm%20ambient%20lighting%20showcasing%20texture&width=600&height=400&seq=portfolio-decorative1&orientation=landscape',
    description: "Application de revêtements décoratifs dans une maison privée"
  },
  {
    id: 6,
    title: "Peinture d'un objet commercial",
    category: 'Peinture et revêtements',
    location: 'Vaud',
    image: 'https://readdy.ai/api/search-image?query=Commercial%20space%20painting%20project%20in%20Vaud%20Switzerland%2C%20large%20interior%20walls%20being%20professionally%20painted%2C%20modern%20business%20environment%2C%20quality%20paint%20application%2C%20clean%20professional%20workspace%2C%20Swiss%20construction%20standards&width=600&height=400&seq=portfolio-commercial1&orientation=landscape',
    description: "Peinture d'un restaurant avec des matériaux premium"
  },

  // Floor Coverings
  {
    id: 7,
    title: 'Pose de parquet',
    category: 'Revêtements de sol',
    location: 'Genève',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20parquet%20flooring%20installation%20in%20Geneva%20home%2C%20professional%20craftsman%20laying%20high%20quality%20wooden%20floor%2C%20elegant%20herringbone%20pattern%2C%20natural%20wood%20tones%2C%20precision%20work%20and%20perfect%20alignment%2C%20bright%20natural%20lighting&width=600&height=400&seq=portfolio-parquet1&orientation=landscape',
    description: 'Installation de parquet premium'
  },
  {
    id: 8,
    title: 'Carrelage en céramique',
    category: 'Revêtements de sol',
    location: 'Lausanne',
    image: 'https://readdy.ai/api/search-image?query=Professional%20ceramic%20tile%20installation%20in%20Swiss%20bathroom%2C%20modern%20large%20format%20tiles%20being%20laid%2C%20precise%20alignment%20and%20spacing%2C%20quality%20materials%20and%20craftsmanship%2C%20clean%20contemporary%20design%2C%20natural%20lighting%20showing%20perfect%20finish&width=600&height=400&seq=portfolio-tiles1&orientation=landscape',
    description: 'Pose de carrelage dans la salle de bain et la cuisine'
  },
  {
    id: 9,
    title: 'Stratifié en bureau',
    category: 'Revêtements de sol',
    location: 'Vaud',
    image: 'https://readdy.ai/api/search-image?query=Modern%20laminate%20flooring%20installation%20in%20Swiss%20office%20space%2C%20professional%20workers%20laying%20quality%20laminate%2C%20contemporary%20wood-look%20finish%2C%20clean%20business%20environment%2C%20precise%20installation%20technique%2C%20bright%20natural%20lighting&width=600&height=400&seq=portfolio-laminate1&orientation=landscape',
    description: 'Installation de stratifié dans un espace de bureau'
  },

  // Facades and Exterior Insulation
  {
    id: 10,
    title: 'Isolation de façade de maison',
    category: 'Façades et isolation',
    location: 'Vaud',
    image: 'https://readdy.ai/api/search-image?query=Professional%20facade%20insulation%20work%20on%20Swiss%20house%20exterior%2C%20workers%20installing%20thermal%20insulation%20panels%20on%20building%20facade%2C%20modern%20construction%20materials%2C%20Alpine%20landscape%20background%2C%20quality%20exterior%20renovation%20work&width=600&height=400&seq=portfolio-insulation1&orientation=landscape',
    description: "Isolation complète et revêtement d'une maison privée"
  },
  {
    id: 11,
    title: "Rénovation de façade d'immeuble",
    category: 'Façades et isolation',
    location: 'Genève',
    image: 'https://readdy.ai/api/search-image?query=Building%20facade%20renovation%20in%20Geneva%20Switzerland%2C%20workers%20on%20scaffolding%20restoring%20exterior%20walls%2C%20modern%20facade%20materials%20and%20finishes%2C%20professional%20construction%20work%2C%20urban%20Swiss%20architecture%2C%20quality%20craftsmanship&width=600&height=400&seq=portfolio-facade1&orientation=landscape',
    description: "Restauration et peinture de façade d'un immeuble"
  },
  {
    id: 12,
    title: 'Crépi de façade',
    category: 'Façades et isolation',
    location: 'Montreux',
    image: 'https://readdy.ai/api/search-image?query=Exterior%20facade%20plastering%20work%20on%20Swiss%20villa%2C%20professional%20rendering%20application%20on%20building%20exterior%2C%20smooth%20quality%20finish%2C%20modern%20construction%20techniques%2C%20Lake%20Geneva%20region%20landscape%2C%20high-end%20craftsmanship&width=600&height=400&seq=portfolio-render1&orientation=landscape',
    description: 'Application de crépi décoratif sur façade de villa'
  },

  // Other Specific Projects
  {
    id: 13,
    title: "Rénovation complète d'appartement",
    category: 'Projets spéciaux',
    location: 'Genève',
    image: 'https://readdy.ai/api/search-image?query=Complete%20apartment%20renovation%20transformation%20in%20Geneva%2C%20before%20and%20after%20modern%20interior%20redesign%2C%20comprehensive%20construction%20work%2C%20quality%20finishes%20throughout%2C%20contemporary%20Swiss%20living%20space%2C%20bright%20natural%20lighting&width=600&height=400&seq=portfolio-renovation1&orientation=landscape',
    description: "Rénovation complète avec réaménagement et nouveau design"
  },
  {
    id: 14,
    title: 'Transformation de restaurant',
    category: 'Projets spéciaux',
    location: 'Lausanne',
    image: 'https://readdy.ai/api/search-image?query=Restaurant%20transformation%20project%20in%20Lausanne%20Switzerland%2C%20modern%20dining%20space%20renovation%20with%20new%20flooring%20walls%20and%20finishes%2C%20professional%20commercial%20construction%2C%20elegant%20hospitality%20design%2C%20quality%20craftsmanship%20throughout&width=600&height=400&seq=portfolio-restaurant1&orientation=landscape',
    description: "Reconstruction complète d'un restaurant avec nouveau concept"
  },
  {
    id: 15,
    title: 'Rénovation de bâtiment historique',
    category: 'Projets spéciaux',
    location: 'Vaud',
    image: 'https://readdy.ai/api/search-image?query=Historic%20building%20renovation%20in%20Vaud%20Switzerland%2C%20careful%20restoration%20work%20preserving%20original%20character%2C%20quality%20craftsmanship%20on%20traditional%20architecture%2C%20modern%20standards%20applied%20to%20heritage%20property%2C%20Swiss%20Alps%20background&width=600&height=400&seq=portfolio-historic1&orientation=landscape',
    description: 'Restauration soignée préservant le caractère historique'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Johnson',
    location: 'Genève',
    rating: 5,
    text: 'Travaux de rénovation exceptionnels dans notre appartement. L\'équipe était professionnelle, ponctuelle et a livré une qualité exceptionnelle. Je recommande vivement Alpbuild.',
    project: 'Rénovation d\'appartement'
  },
  {
    id: 2,
    name: 'Michael Weber',
    location: 'Lausanne',
    rating: 5,
    text: 'Excellent travail de façade et d\'isolation. Le projet a été terminé dans les délais et le budget. Très satisfait de l\'approche professionnelle.',
    project: 'Isolation de façade'
  },
  {
    id: 3,
    name: 'Elena Rossi',
    location: 'Montreux',
    rating: 5,
    text: 'Travaux de peinture et finition parfaits dans notre nouvelle maison. Travail propre et précis avec des matériaux de haute qualité.',
    project: 'Peinture intérieure'
  },
  {
    id: 4,
    name: 'David Martinez',
    location: 'Vaud',
    rating: 5,
    text: 'Rénovation complète du bureau gérée professionnellement du début à la fin. Excellente communication et résultats exceptionnels.',
    project: 'Rénovation de bureau'
  }
];
